import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=6d9e4f1d&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Register.vue?vue&type=style&index=1&id=6d9e4f1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e4f1d",
  null
  
)

export default component.exports